/**
 * How a visit takes place (blhWebServer docs/AVAILABILITY_MODEL_V2.md §2.7):
 * the HL7 service-mode codes "in-person" | "videoconference" | "telephone",
 * named "In person" / "Video" / "Phone" on every screen. "Virtual" is derived
 * — a video or a phone visit is remote — and never a label of its own.
 *
 * Read the way the server reads it: the appointment's own `mode` /
 * `deliveryMode`, then the older `appointmentType` word, then its booleans. A
 * meeting link is no evidence (links were never cleared when a visit moved to
 * in person).
 */
export const LABELS = {"in-person": "In person", videoconference: "Video", telephone: "Phone"};

const WORDS = {
  "in-person": "in-person",
  in_person: "in-person",
  live: "in-person",
  videoconference: "videoconference",
  video: "videoconference",
  virtual: "videoconference",
  teleconference: "videoconference",
  telehealth: "videoconference",
  telephone: "telephone",
  phone: "telephone",
};

/** The code a word names, in any vocabulary the app has seen; null otherwise. */
export function deliveryModeFrom(word) {
  if (typeof word !== "string") return null;
  return WORDS[word.trim().toLowerCase()] || null;
}

const isTrue = (value) => value === true || value === "true";

/** How an appointment takes place, as a code; null when it never said. */
export function deliveryModeOfAppointment(appointment) {
  if (!appointment) return null;
  return (
    deliveryModeFrom(appointment.mode) ||
    deliveryModeFrom(appointment.deliveryMode) ||
    deliveryModeFrom(appointment.appointmentType) ||
    (isTrue(appointment.telephone) ? "telephone" : null) ||
    (isTrue(appointment.teleconference) ? "videoconference" : null)
  );
}

/** "In person", "Video", "Phone"; "" for anything else. */
export function deliveryModeLabel(word) {
  return LABELS[deliveryModeFrom(word)] || "";
}

/** A video or a phone visit: attended from wherever the patient is. */
export function isRemote(word) {
  const code = deliveryModeFrom(word);
  return code === "videoconference" || code === "telephone";
}
